import { motion } from 'framer-motion';
import { PageTransition, FadeIn, StaggerContainer, StaggerItem } from '../components/PageTransition';
import { BackButton } from '../components/BackButton';
import { StaticCard, TrainingReferenceLink } from '../components/BorderCard';

const guidelines = [
  'Stock category segregation',
  'Alphabetical style code arrangement',
  'Rack flow left to right, top to bottom',
  'Rack condition standards',
  'Cleanliness and organization',
  'Carton handling rules',
  'Hanger management',
  'Footwear barcode visibility',
  'Accessories storage in bins',
  'Daily checklist standards'
];

const StockRoomPage = () => {
  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] py-24 px-6">
      <div className="grain-overlay" />
      <BackButton to="/what" label="Back" />

      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#1A1A1A]/60 mb-4">
            Training Module
          </h2>
          <h1 className="text-4xl md:text-5xl font-light tracking-tight text-[#1A1A1A] mb-4">
            Stock Room Guidelines
          </h1>
          <TrainingReferenceLink 
            href="https://www.canva.com/design/DAHBpXjqfhA/_k5oASvYCn_ZUyx5yL47Nw/view?utm_content=DAHBpXjqfhA&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hdc6537b13e"
          />
          <p className="text-sm text-[#1A1A1A]/60 mt-4 max-w-xl mx-auto">
            Inventory management and storage organization standards
          </p>
        </motion.div>

        {/* Guidelines List */}
        <FadeIn delay={0.2}>
          <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-center text-[#1A1A1A]/60 mb-8">
            Guidelines Covered
          </h3>
        </FadeIn>
        
        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12">
          {guidelines.map((guideline, index) => (
            <StaggerItem key={index}>
              <StaticCard className="p-5">
                <div className="flex items-center gap-4">
                  <div className="flex items-center justify-center w-8 h-8 border border-[#D32F2F]/30 bg-[#D32F2F]/5 text-[#D32F2F] text-xs font-semibold">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <span className="text-sm text-[#1A1A1A]">{guideline}</span>
                </div>
              </StaticCard>
            </StaggerItem>
          ))}
        </StaggerContainer>

        {/* Important Note */}
        <FadeIn delay={0.5}>
          <StaticCard className="max-w-2xl mx-auto p-8 text-center">
            <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1A1A1A]/60 mb-4">
              Remember
            </h4>
            <p className="text-base font-light text-[#1A1A1A] italic">
              "A well-organized stock room is the backbone of efficient store operations."
            </p>
          </StaticCard>
        </FadeIn>
      </div>
    </PageTransition>
  );
};

export default StockRoomPage;
